import { action, observable, makeObservable } from 'mobx';

export interface IDeviceGroup {
    id: string;
    name: string;
    description: string;
    deviceType?: Array<string>;
}

export default class ControllerStore {
    deviceGroup: IDeviceGroup = {
        id: '',
        name: '',
        description: '',
        deviceType: []
    };

    constructor(controller: IDeviceGroup) {
        makeObservable(this, {
            deviceGroup: observable,
            update: action
        });

        this.update(controller);
    }

    update(deviceGroup: IDeviceGroup): void {
        this.deviceGroup = {
            ...this.deviceGroup,
            ...deviceGroup
        };
    }
}
